import React from 'react';

import { ContributionSelection, getSelectionState } from '~support-at-home/lib/contributionSelection';

import { ClickableIcon } from '~components';
import { faPlus } from '~components/icon';
import { Row } from '~components/table-view';
import ContributionSelectCheckbox, {
  SelectSlotPlaceholder,
} from '~support-at-home/components/config/contributions/ContributionSelectCheckbox';

interface ComponentProps {
  row: Row;
  // Whether the (+) is offered for this client. Always false for a client that cannot be resolved.
  canAdd?: boolean;
  onAdd?: (clientId: number) => void;
  selection?: ContributionSelection;
}

// The heading row of a client's group: name, how many contributions it has, and the (+) that
// starts a new contribution for that client.
const ContributionClientCell: React.FC<ComponentProps> = ({ row, canAdd = false, onAdd, selection }) => {
  const name = row.client_name || `Unknown client (#${row.client_id})`;
  const showAdd = canAdd && row.has_client !== false;
  const selectableIds = selection?.selectableIdsByClient.get(row.client_id) ?? [];
  const state = selection ? getSelectionState(selectableIds, selection.selectedIds) : 'none';

  return (
    <div className="contribution-client-cell d-flex align-items-center gap-2">
      {selection &&
        (selectableIds.length > 0 ? (
          <ContributionSelectCheckbox
            id={`sah-client-contributions-select-client-${row.client_id}`}
            label={`Select all current and future contributions for ${name}`}
            checked={state === 'all'}
            indeterminate={state === 'some'}
            anySelected={selection.selectedIds.size > 0}
            onChange={() => selection.onToggleClient(row.client_id)}
          />
        ) : (
          <SelectSlotPlaceholder />
        ))}
      <span className="client-name" title={name}>
        {name}
      </span>
      <span className="badge rounded-pill text-bg-light border" title="Contributions">
        {row.count}
      </span>
      {showAdd && (
        <ClickableIcon
          id={`sah-client-contributions-add-row-${row.client_id}`}
          icon={faPlus}
          size="small"
          color="success"
          toolTip="Add contribution"
          ariaLabel={`Add contribution for ${name}`}
          onClick={() => onAdd?.(row.client_id)}
        />
      )}
    </div>
  );
};

export default ContributionClientCell;
